import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import QrReader from 'react-qr-reader';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { Helmet } from 'react-helmet-async';

export default function QRScanner() {
    const navigate = useNavigate();
    const [data, setData] = useState('No result');
    const [manualCode, setManualCode] = useState('');
    const [error, setError] = useState('');

    const handleScan = (data) => {
        if (data) {
            setData(data);
            try {
                // Check if it's a URL first
                let url;
                try {
                    url = new URL(data);
                } catch {
                    // Not a URL, maybe just codes
                }

                if (url && url.searchParams.has('table')) {
                    const tableId = url.searchParams.get('table');
                    const businessId = url.searchParams.get('business');

                    if (tableId) localStorage.setItem('currentTable', tableId);
                    if (businessId) localStorage.setItem('currentBusinessId', businessId);

                    navigate(`/menu?table=${tableId}&business=${businessId || ''}`);
                } else if (data.includes('menu?table=')) {
                    // Fallback for older textual/relative formats
                    const params = new URLSearchParams(data.split('?')[1]);
                    const tableId = params.get('table');
                    const businessId = params.get('business');

                    if (tableId) localStorage.setItem('currentTable', tableId);
                    if (businessId) localStorage.setItem('currentBusinessId', businessId);

                    navigate(`/menu?table=${tableId}&business=${businessId || ''}`);
                } else {
                    setError('Invalid QR Code. Please scan a table QR code.');
                }
            } catch (err) {
                setError('Error parsing QR code.');
            }
        }
    };

    const handleError = (err) => {
        console.error(err);
        setError('Could not access camera. Please ensure permissions are granted.');
    };

    const handleManualSubmit = (e) => {
        e.preventDefault();
        if (manualCode) {
            // For manual code, we assume it's just table ID. 
            // If logged in, we verify. If guest, this might be tricky without business ID.
            // But let's navigate to menu and let it resolve or ask.
            localStorage.setItem('currentTable', manualCode);
            navigate(`/menu?table=${manualCode}`);
        }
    };

    return (
        <Container className="py-5">
            <Helmet>
                <title>Scan Table QR</title>
            </Helmet>

            <div className="text-center mb-4">
                <h2>Scan Table QR Code</h2>
                <p className="text-muted">Scan the QR code on your table to view the menu and order.</p>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-6 col-lg-4">
                    <Card className="shadow-sm mb-4">
                        <Card.Body className="p-0 overflow-hidden rounded">
                            <QrReader
                                delay={300}
                                onError={handleError}
                                onScan={handleScan}
                                style={{ width: '100%' }}
                            />
                        </Card.Body>
                        <Card.Footer className="text-center">
                            <small className="text-muted">Align QR code within the frame</small>
                        </Card.Footer>
                    </Card>

                    {error && <div className="alert alert-danger">{error}</div>}

                    <div className="text-center my-3 relative">
                        <span className="bg-light px-3 text-muted">OR</span>
                    </div>

                    <Card className="shadow-sm">
                        <Card.Body>
                            <h5 className="mb-3">Enter Table Code</h5>
                            <Form onSubmit={handleManualSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Control
                                        type="text"
                                        placeholder="e.g. T-12"
                                        value={manualCode}
                                        onChange={(e) => setManualCode(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                                <div className="d-grid">
                                    <Button variant="primary" type="submit">
                                        Go to Menu
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </Container>
    );
}
